import React from 'react';

export default function BulkActionsBar({
  selectedCount,
  onClear,
  onSelectAll,
  onDelete,
  selectAllLabel = 'Seleccionar visibles',
  deleteLabel = 'Eliminar seleccionados',
  disabled = false,
}) {
  if (!selectedCount) return null;

  return (
    <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
      <div className="flex flex-col gap-3 max-lg:items-stretch lg:flex-row lg:items-center lg:justify-between">
        <div className="shrink-0 whitespace-nowrap text-sm font-medium text-gray-700 tabular-nums max-lg:w-full max-lg:text-center lg:text-left">
          {selectedCount} seleccionado{selectedCount === 1 ? '' : 's'}
        </div>
        {/* Por debajo de `lg` la barra tiene dos formas según la orientación (es la
            convención de este componente, anterior a la regla de ancho de la skill):
            en vertical, apilada a ancho completo; en apaisado, los tres botones en
            UNA fila con rejilla 1fr/auto/1fr — el primero pegado a la izquierda, el
            del medio centrado en el ancho TOTAL (no solo con el mismo hueco a los
            lados, que no es lo mismo si los otros dos miden distinto) y el de borrar
            al borde derecho. Padding recortado para que quepan en un móvil apaisado.
            Lo pidió Iván para Tiendas y Superusuarios (FE #723) y lo conseguía desde
            fuera con un selector por posición; vive aquí para que no dependa de la
            estructura interna. */}
        <div className="flex flex-wrap items-center gap-2 max-lg:portrait:grid max-lg:portrait:w-full max-lg:portrait:grid-cols-1 max-lg:portrait:gap-2 max-lg:landscape:grid max-lg:landscape:grid-cols-[1fr_auto_1fr] max-lg:landscape:items-center">
          {onSelectAll ? (
            <button
              type="button"
              onClick={onSelectAll}
              className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm font-semibold hover:bg-gray-200 transition-colors max-lg:portrait:w-full max-lg:portrait:py-2.5 max-lg:portrait:text-center max-lg:landscape:px-1.5 max-lg:landscape:justify-self-start"
            >
              {selectAllLabel}
            </button>
          ) : null}
          <button
            type="button"
            onClick={onClear}
            className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm font-semibold hover:bg-gray-200 transition-colors max-lg:portrait:w-full max-lg:portrait:py-2.5 max-lg:portrait:text-center max-lg:landscape:px-1.5 max-lg:landscape:justify-self-center"
          >
            Limpiar selección
          </button>
          <button
            type="button"
            disabled={disabled}
            onClick={onDelete}
            className="px-4 py-2 rounded-lg bg-red-600 text-white text-sm font-semibold hover:bg-red-700 disabled:opacity-60 disabled:cursor-not-allowed transition-colors max-lg:portrait:w-full max-lg:portrait:py-2.5 max-lg:portrait:text-center max-lg:landscape:px-1.5 max-lg:landscape:justify-self-end"
          >
            {deleteLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
